<template>
  <header>
    <router-link class="home" to="/">
      <h1>N-Leach</h1>
    </router-link>
    <nav role="main" v-show="!hideNav">
      <router-link
        :class="{ 'active' : this.$route.name == 'input' }"
        to="/input">
        {{$t('ui.input-data')}}
        <nav-marker class="marker"/>
      </router-link>
      <router-link
        :class="{ 'active' : this.$route.name == 'output' }"
        to="/output">
        {{$t('ui.simulation')}}
        <nav-marker class="marker"/>
      </router-link>
      <router-link
        :class="{ 'active' : this.$route.name == 'editor' }"
        to="/editor"
        v-if="hasEditor">
        {{$t('ui.editor')}}
        <nav-marker class="marker"/>
      </router-link>
    </nav>
    <div class="language-selector">
      <button
        :class="{ 'active' : $i18n.i18next.language == 'es' }"
        @click="changeLanguage('es')"
        type="button">
        ES
      </button>
      <span class="divider">|</span>
      <button
        :class="{ 'active' : $i18n.i18next.language == 'en' }"
        @click="changeLanguage('en')"
        type="button">
        EN
      </button>
    </div>
  </header>
</template>

<style lang="scss" scoped>

header {
  height: var(--height--header);
  min-height: var(--height--header);
  position: sticky;
  top: 0;
  background: var(--background--gradient);
  background-image:
    url("~@/assets/images/pattern-bg.png"),
    var(--background--gradient);
  display: flex;
  align-items: stretch;
  justify-content: center;
  padding: 0 $spacing--m;
  z-index: 2;
}

.home {
  position: absolute;
  left: $spacing--m;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
}

h1 {
  font-size: 1.25rem;
  text-transform: uppercase;
  color: var(--color--white);
}

nav {
  flex: 1;
  @extend %text-style--button;
  height: 100%;
  display: flex;
  justify-content: center;
  a {
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    color: var(--color--white);
    padding: 0 $spacing--m;
    opacity: 0.75;
    transition: 120ms ease-out;
    &:hover {
      opacity: 1;
    }
    &.active {
      opacity: 1;
      .marker {
        opacity: 1;
        transform: translate(-50%, 0);
      }
    }
  }
  .marker {
    position: absolute;
    fill: var(--color--white);
    left: 50%;
    bottom: 0;
    opacity: 0;
    transform: translate(-50%, 1rem);
    transition: 240ms ease-out;
  }
}

.language-selector {
  position: absolute;
  right: $spacing--m;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  color: var(--color--dark--secondary);
  button {
    padding: 0.25rem;
    background-color: transparent;
    color: var(--color--dark--secondary);
    &.active {
      pointer-events: none;
      color: var(--color--dark--primary);
    }
  }
}

</style>

<script>
import NavMarker from '@/components/NavMarker'
import { hasEditor } from '@/helpers/env'

export default {
  props: {
    hideNav: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'nav-marker': NavMarker
  },
  computed: {
    hasEditor: () => hasEditor
  },
  methods: {
    changeLanguage (lang) {
      this.$i18n.i18next.changeLanguage(lang)
    }
  }
}
</script>
